'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require('@material-ui/core/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (path) {
  var Icon = function Icon(props) {
    return _react2.default.createElement(
      _SvgIcon2.default,
      props,
      _react2.default.createElement('path', { d: path })
    );
  };
  Icon.muiName = 'SvgIcon';
  return Icon;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mdi-material-ui/util/createIcon.js
// module id = 672
// module chunks = 0